// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.related-videos_wrapper__amy\\+Z {
  z-index: 2; /* on small player, the pagination needs to be above the bottom bar */

  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
  max-height: calc(100% - 72px);
}

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg {
    overflow: hidden;
    display: grid;
    grid-auto-rows: var(--related-videos-card-height);
    grid-template-columns: repeat(auto-fit, var(--related-videos-card-width));
    grid-gap: var(--related-videos-gap);
    gap: var(--related-videos-gap);
    align-content: center;
    justify-content: center;

    width: 100%;
    height: 100%;
    padding: var(--related-videos-padding) var(--related-videos-padding) 0 var(--related-videos-padding);
  }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr {
      cursor: pointer;

      display: flex;
      gap: 20px;
      align-items: center;

      min-height: var(--related-videos-card-height);
      padding: 20px;
      border-radius: 2px;

      color: var(--textColor);
      -webkit-text-decoration: none;
      text-decoration: none;

      background: var(--backgroundColor);
      outline: 0px solid var(--primaryColor);
      box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);

      transition: transform 0.2s;
      animation: related-videos_slideUp__ZpxWL 0.5s ease 0s 1 normal forwards;
    }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr:focus-visible {
        transform: scale(1.05);
        outline: 2px solid var(--primaryColor);
      }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr:hover {
        transform: scale(1.05);
        outline: 2px solid var(--primaryColor);
      }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr:focus-visible .related-videos_playCircleIcon__ztytN {
          opacity: 1;
        }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr:hover .related-videos_playCircleIcon__ztytN {
          opacity: 1;
        }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_cardContent__iN2Kf {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: space-between;

        height: 100%;
      }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_cardContent__iN2Kf .related-videos_title__l-cn9 {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;

          font-size: 16px;
          font-weight: 700;
          line-height: 25px;
          color: var(--textColor);
          text-align: left;
          word-wrap: anywhere;
        }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I,.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I img {
        position: relative;

        aspect-ratio: 16 / 9;
        width: 150px;
        max-width: 150px;
        max-height: 84px;

        background-color: #000000;
      }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I:not(does-not-exist) .related-videos_playCircleIcon__ztytN,.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I img .related-videos_playCircleIcon__ztytN {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          width: 32px;
          height: 32px;

          opacity: 0;

          transition: opacity 0.2s;
        }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I:not(does-not-exist) .related-videos_playCircleIcon__ztytN svg,.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I img .related-videos_playCircleIcon__ztytN svg {
            width: 100%;
            height: 100%;
          }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I:not(does-not-exist) .related-videos_playCircleIcon__ztytN circle,.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I img .related-videos_playCircleIcon__ztytN circle {
            fill: var(--primaryColor);
          }

.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I:not(does-not-exist) .related-videos_playCircleIcon__ztytN path,.related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I img .related-videos_playCircleIcon__ztytN path {
            fill: var(--overlayForeground);
          }

@media (prefers-contrast: more) {
        .related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr {
          border: 1px solid var(--textColor);
          box-shadow: none;
        }
      }

.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC {
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: center;
  }

.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_prevPageButton__mvi-P,.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_nextPageButton__eQ8k- {
      cursor: pointer;

      width: 24px;
      height: 24px;
      padding: 0;
      border: 0;
      border-radius: 2px;

      background-color: var(--backgroundColor);
      box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);

      transition: transform 0.2s;
    }

.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_prevPageButton__mvi-P:disabled {
        cursor: default;
        opacity: 0.5;
      }

.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_nextPageButton__eQ8k-:disabled {
        cursor: default;
        opacity: 0.5;
      }

.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_prevPageButton__mvi-P:not(:disabled):hover {
          transform: scale(1.1);
          outline: 2px solid var(--primaryColor);
        }

.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_nextPageButton__eQ8k-:not(:disabled):hover {
          transform: scale(1.1);
          outline: 2px solid var(--primaryColor);
        }

.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_prevPageButton__mvi-P:not(:disabled):focus-visible {
          transform: scale(1.1);
          outline: 2px solid var(--primaryColor);
        }

.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_nextPageButton__eQ8k-:not(:disabled):focus-visible {
          transform: scale(1.1);
          outline: 2px solid var(--primaryColor);
        }

.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_prevPageButton__mvi-P .related-videos_chevronLeftSvg__\\+soEk,.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_nextPageButton__eQ8k- .related-videos_chevronLeftSvg__\\+soEk,.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_prevPageButton__mvi-P .related-videos_chevronRightSvg__k7QRl,.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_nextPageButton__eQ8k- .related-videos_chevronRightSvg__k7QRl {
        width: 24px;
        height: 24px;
        padding: 6px;

        color: var(--textColor);

        fill: var(--textColor);
      }

@media (prefers-contrast: more) {
        .related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_prevPageButton__mvi-P,.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_nextPageButton__eQ8k- {
          border: 1px solid var(--textColor);
          box-shadow: none;
        }
      }

.related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_prevPageButton__mvi-P .related-videos_chevronLeftSvg__\\+soEk {
      transform: rotate(180deg);
    }

.related-videos_overlay__lrRJG {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  opacity: 0.33333;
  background-color: var(--videoBackground);

  animation: related-videos_fadeIn__fE\\+tS 0.5s ease 0s 1 normal forwards;
}

.smallScreen .related-videos_wrapper__amy\\+Z {
    gap: 5px;
    margin-bottom: -30px;
  }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg {
      grid-auto-rows: 1fr;
    }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr {
        width: 100%;
        min-width: auto;
        height: 100%;
        min-height: auto;
        padding: 12px 20px;
      }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr:hover {
          transform: none;
        }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr:focus-visible {
          transform: none;
        }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I {
          width: 100%;
          max-width: 100px;
          max-height: 56px;
        }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_thumbnail__z1g0I img {
          width: 100%;
          max-width: 100px;
          max-height: 56px;
        }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_cardContent__iN2Kf {
          gap: 5px;
        }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_grid__jP6eg .related-videos_card__dniAr .related-videos_cardContent__iN2Kf .related-videos_title__l-cn9 {
            font-size: 12px;
            line-height: 14.63px;
          }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_prevPageButton__mvi-P:hover {
          transform: none;
        }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_nextPageButton__eQ8k-:hover {
          transform: none;
        }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_prevPageButton__mvi-P:focus-visible {
          transform: none;
        }

.smallScreen .related-videos_wrapper__amy\\+Z .related-videos_pagination__8EKBC .related-videos_nextPageButton__eQ8k-:focus-visible {
          transform: none;
        }

@media (prefers-reduced-motion) {
  .related-videos_card__dniAr {
    transition: none;
    animation: none;
  }
}

@keyframes related-videos_slideUp__ZpxWL {
  0% {
    position: relative;
    top: 20px;
    opacity: 0;
  }

  100% {
    position: relative;
    top: 0;
    opacity: 1;
  }
}

@keyframes related-videos_fadeIn__fE\\+tS {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.33333;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/related-videos/related-videos.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU,EAAE,qEAAqE;;EAEjF,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;EACZ,6BAA6B;AA8K/B;;AA5KE;IACE,gBAAgB;IAChB,aAAa;IACb,iDAAiD;IACjD,yEAAyE;IACzE,mCAA8B;IAA9B,8BAA8B;IAC9B,qBAAqB;IACrB,uBAAuB;;IAEvB,WAAW;IACX,YAAY;IACZ,oGAAoG;EAuGtG;;AArGE;MACE,eAAe;;MAEf,aAAa;MACb,SAAS;MACT,mBAAmB;;MAEnB,6CAA6C;MAC7C,aAAa;MACb,kBAAkB;;MAElB,uBAAuB;MACvB,6BAAqB;MAArB,qBAAqB;;MAErB,kCAAkC;MAClC,sCAAsC;MACtC,+CAA+C;;MAE/C,0BAA0B;MAC1B,uEAAiD;IAiFnD;;AA/EE;QAEE,sBAAsB;QACtB,sCAAsC;MAKxC;;AARA;QAEE,sBAAsB;QACtB,sCAAsC;MAKxC;;AAHE;UACE,UAAU;QACZ;;AAFA;UACE,UAAU;QACZ;;AAGF;QACE,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,uBAAuB;QACvB,8BAA8B;;QAE9B,YAAY;MAed;;AAbE;UACE,gBAAgB;UAChB,oBAAoB;UACpB,4BAA4B;UAC5B,qBAAqB;;UAErB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,uBAAuB;UACvB,gBAAgB;UAChB,mBAAuB;QACzB;;AAGF;QAEE,kBAAkB;;QAElB,oBAAoB;QACpB,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;;QAEhB,yBAAyB;MA4B3B;;AA1BE;UACE,kBAAkB;UAClB,QAAQ;UACR,SAAS;UACT,gCAAgC;;UAEhC,WAAW;UACX,YAAY;;UAEZ,UAAU;;UAEV,wBAAwB;QAc1B;;AAZE;YACE,WAAW;YACX,YAAY;UACd;;AAEA;YACE,yBAAyB;UAC3B;;AAEA;YACE,8BAA8B;UAChC;;AAIJ;QACE;UACE,kCAAkC;UAClC,gBAAgB;QAClB;MACF;;AAIJ;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;EAmDzB;;AAjDE;MAEE,eAAe;;MAEf,WAAW;MACX,YAAY;MACZ,UAAU;MACV,SAAS;MACT,kBAAkB;;MAElB,wCAAwC;MACxC,+CAA+C;;MAE/C,0BAA0B;IAgC5B;;AA9BE;QACE,eAAe;QACf,YAAY;MACd;;AAHA;QACE,eAAe;QACf,YAAY;MACd;;AAGE;UAEE,qBAAqB;UACrB,sCAAsC;QACxC;;AAJA;UAEE,qBAAqB;UACrB,sCAAsC;QACxC;;AAJA;UAEE,qBAAqB;UACrB,sCAAsC;QACxC;;AAJA;UAEE,qBAAqB;UACrB,sCAAsC;QACxC;;AAGF;QAEE,WAAW;QACX,YAAY;QACZ,YAAY;;QAEZ,uBAAuB;;QAEvB,sBAAsB;MACxB;;AAEA;QACE;UACE,kCAAkC;UAClC,gBAAgB;QAClB;MACF;;AAEF;MACE,yBAAyB;IAC3B;;AAIJ;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;;EAEP,WAAW;EACX,YAAY;;EAEZ,gBAAgB;EAChB,wCAAwC;;EAExC,uEAAgD;AAClD;;AAGE;IACE,QAAQ;IACR,oBAAoB;EA2CtB;;AAzCE;MACE,mBAAmB;IA6BrB;;AA3BE;QACE,WAAW;QACX,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;MAqBpB;;AAnBE;UAEE,eAAe;QACjB;;AAHA;UAEE,eAAe;QACjB;;AAEA;UAEE,WAAW;UACX,gBAAgB;UAChB,gBAAgB;QAClB;;AALA;UAEE,WAAW;UACX,gBAAgB;UAChB,gBAAgB;QAClB;;AACA;UACE,QAAQ;QAMV;;AAJE;YACE,eAAe;YACf,oBAAoB;UACtB;;AAQF;UAEE,eAAe;QACjB;;AAHA;UAEE,eAAe;QACjB;;AAHA;UAEE,eAAe;QACjB;;AAHA;UAEE,eAAe;QACjB;;AAMR;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".wrapper {\n  z-index: 2; /* on small player, the pagination needs to be above the bottom bar */\n\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  height: 100%;\n  max-height: calc(100% - 72px);\n\n  & .grid {\n    overflow: hidden;\n    display: grid;\n    grid-auto-rows: var(--related-videos-card-height);\n    grid-template-columns: repeat(auto-fit, var(--related-videos-card-width));\n    gap: var(--related-videos-gap);\n    align-content: center;\n    justify-content: center;\n\n    width: 100%;\n    height: 100%;\n    padding: var(--related-videos-padding) var(--related-videos-padding) 0 var(--related-videos-padding);\n\n    & .card {\n      cursor: pointer;\n\n      display: flex;\n      gap: 20px;\n      align-items: center;\n\n      min-height: var(--related-videos-card-height);\n      padding: 20px;\n      border-radius: 2px;\n\n      color: var(--textColor);\n      text-decoration: none;\n\n      background: var(--backgroundColor);\n      outline: 0px solid var(--primaryColor);\n      box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);\n\n      transition: transform 0.2s;\n      animation: slideUp 0.5s ease 0s 1 normal forwards;\n\n      &:hover,\n      &:focus-visible {\n        transform: scale(1.05);\n        outline: 2px solid var(--primaryColor);\n\n        & .playCircleIcon {\n          opacity: 1;\n        }\n      }\n\n      & .cardContent {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        align-items: flex-start;\n        justify-content: space-between;\n\n        height: 100%;\n\n        & .title {\n          overflow: hidden;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: 3;\n\n          font-size: 16px;\n          font-weight: 700;\n          line-height: 25px;\n          color: var(--textColor);\n          text-align: left;\n          overflow-wrap: anywhere;\n        }\n      }\n\n      & .thumbnail,\n      & .thumbnail img {\n        position: relative;\n\n        aspect-ratio: 16 / 9;\n        width: 150px;\n        max-width: 150px;\n        max-height: 84px;\n\n        background-color: #000000;\n\n        & .playCircleIcon {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n\n          width: 32px;\n          height: 32px;\n\n          opacity: 0;\n\n          transition: opacity 0.2s;\n\n          & svg {\n            width: 100%;\n            height: 100%;\n          }\n\n          & circle {\n            fill: var(--primaryColor);\n          }\n\n          & path {\n            fill: var(--overlayForeground);\n          }\n        }\n      }\n\n      @media (prefers-contrast: more) {\n        & {\n          border: 1px solid var(--textColor);\n          box-shadow: none;\n        }\n      }\n    }\n  }\n\n  & .pagination {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    justify-content: center;\n\n    & .prevPageButton,\n    & .nextPageButton {\n      cursor: pointer;\n\n      width: 24px;\n      height: 24px;\n      padding: 0;\n      border: 0;\n      border-radius: 2px;\n\n      background-color: var(--backgroundColor);\n      box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);\n\n      transition: transform 0.2s;\n\n      &:disabled {\n        cursor: default;\n        opacity: 0.5;\n      }\n\n      &:not(:disabled) {\n        &:hover,\n        &:focus-visible {\n          transform: scale(1.1);\n          outline: 2px solid var(--primaryColor);\n        }\n      }\n\n      & .chevronLeftSvg,\n      & .chevronRightSvg {\n        width: 24px;\n        height: 24px;\n        padding: 6px;\n\n        color: var(--textColor);\n\n        fill: var(--textColor);\n      }\n\n      @media (prefers-contrast: more) {\n        & {\n          border: 1px solid var(--textColor);\n          box-shadow: none;\n        }\n      }\n    }\n    & .prevPageButton .chevronLeftSvg {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  width: 100%;\n  height: 100%;\n\n  opacity: 0.33333;\n  background-color: var(--videoBackground);\n\n  animation: fadeIn 0.5s ease 0s 1 normal forwards;\n}\n\n:global(.smallScreen) {\n  & .wrapper {\n    gap: 5px;\n    margin-bottom: -30px;\n\n    & .grid {\n      grid-auto-rows: 1fr;\n\n      & .card {\n        width: 100%;\n        min-width: auto;\n        height: 100%;\n        min-height: auto;\n        padding: 12px 20px;\n\n        &:hover,\n        &:focus-visible {\n          transform: none;\n        }\n\n        & .thumbnail,\n        & .thumbnail img {\n          width: 100%;\n          max-width: 100px;\n          max-height: 56px;\n        }\n        & .cardContent {\n          gap: 5px;\n\n          & .title {\n            font-size: 12px;\n            line-height: 14.63px;\n          }\n        }\n      }\n    }\n\n    & .pagination {\n      & .prevPageButton,\n      & .nextPageButton {\n        &:hover,\n        &:focus-visible {\n          transform: none;\n        }\n      }\n    }\n  }\n}\n\n@media (prefers-reduced-motion) {\n  .card {\n    transition: none;\n    animation: none;\n  }\n}\n\n@keyframes slideUp {\n  0% {\n    position: relative;\n    top: 20px;\n    opacity: 0;\n  }\n\n  100% {\n    position: relative;\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0.33333;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `related-videos_wrapper__amy+Z`,
	"grid": `related-videos_grid__jP6eg`,
	"card": `related-videos_card__dniAr`,
	"slideUp": `related-videos_slideUp__ZpxWL`,
	"playCircleIcon": `related-videos_playCircleIcon__ztytN`,
	"cardContent": `related-videos_cardContent__iN2Kf`,
	"title": `related-videos_title__l-cn9`,
	"thumbnail": `related-videos_thumbnail__z1g0I`,
	"pagination": `related-videos_pagination__8EKBC`,
	"prevPageButton": `related-videos_prevPageButton__mvi-P`,
	"nextPageButton": `related-videos_nextPageButton__eQ8k-`,
	"chevronLeftSvg": `related-videos_chevronLeftSvg__+soEk`,
	"chevronRightSvg": `related-videos_chevronRightSvg__k7QRl`,
	"overlay": `related-videos_overlay__lrRJG`,
	"fadeIn": `related-videos_fadeIn__fE+tS`
};
module.exports = ___CSS_LOADER_EXPORT___;
